/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getOptionDecoder,
  getOptionEncoder,
  getStructDecoder,
  getStructEncoder,
  getU64Decoder,
  getU64Encoder,
  getU8Decoder,
  getU8Encoder,
  type Codec,
  type Decoder,
  type Encoder,
  type Option,
  type OptionOrNullable,
} from '@solana/kit';

export type ClaimArgs = { scheduleId: Option<number>; amount: bigint };

export type ClaimArgsArgs = {
  scheduleId: OptionOrNullable<number>;
  amount: number | bigint;
};

export function getClaimArgsEncoder(): Encoder<ClaimArgsArgs> {
  return getStructEncoder([
    ['scheduleId', getOptionEncoder(getU8Encoder())],
    ['amount', getU64Encoder()],
  ]);
}

export function getClaimArgsDecoder(): Decoder<ClaimArgs> {
  return getStructDecoder([
    ['scheduleId', getOptionDecoder(getU8Decoder())],
    ['amount', getU64Decoder()],
  ]);
}

export function getClaimArgsCodec(): Codec<ClaimArgsArgs, ClaimArgs> {
  return combineCodec(getClaimArgsEncoder(), getClaimArgsDecoder());
}
